<template>
  <v-container>
    <custom-text msg="custom-text.alerts" class="mt-2 mb-1"></custom-text>
    <v-layout>
      <v-flex pt-4>
        <v-expansion-panel>
          <v-expansion-panel-content v-for="(alert, key) in alerts" :key="key" :value="alert.isOpen"
                                     v-on:input="setAlertState(key)">
            <alert-header slot="header" :alert="alert"/>
            <alert-body :alert="alert" :isOpen="alert.isOpen" :id="alert.id"/>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import AlertBody from './AlertBody'
  import { mapMutations, mapState } from 'vuex'
  import { TOGGLE_ADMIN_ALERT_STATE } from '../../../store/mutation-types'
  import AlertHeader from './AlertHeader'
  import {
    GET_ADMIN_ALERTS,
    GET_CLASS_HIERARCHY
  } from '../../../store/action-types'
  import CustomText from '../../help/CustomText'

  export default {
    name: 'alerts-page',
    components: {
      AlertHeader,
      AlertBody,
      CustomText
    },
    data () {
      return {
        isOpen: false
      }
    },
    methods: {
      ...mapMutations({
        setAlertState: TOGGLE_ADMIN_ALERT_STATE
      })
    },
    computed: {
      ...mapState({
        alerts: state => state.admin.alerts
      })
    },
    mounted () {
      this.$store.dispatch(GET_ADMIN_ALERTS)
      if (this.$store.state.hierarchy.tree === null) {
        this.$store.dispatch(GET_CLASS_HIERARCHY)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertsPage.vue